import { Component, OnInit, isDevMode } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { HelpersService } from '../../../services/helpers.service';
import { UserService } from '../../../services/user.service';
import { PartnerService } from '../../../services/partner.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public form: any = { username: '', password: '' };
  public loggingIn: boolean = false;
  public error: boolean = false;
  public errorMessage: string = '';
  public returnURL: string = null;

  constructor(
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public partnerService: PartnerService,
    public helpersService: HelpersService,
    public router: Router,
    public route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['returnUrl']) {
        this.returnURL = params['returnUrl'];
      }
    });
    this.checkExistingToken();
  }

  checkExistingToken() {
    var profile = this.helpersService.getProfileData();
    var authData = this.helpersService.getAuthData();
    var newAPIAuthData = this.helpersService.getAuthDataNew();

    if (
      authData &&
      newAPIAuthData &&
      profile &&
      authData.token &&
      newAPIAuthData.token &&
      profile.IsSuperUser
    ) {
      this.router.navigateByUrl('/administration/stores');
    } else if (
      authData &&
      newAPIAuthData &&
      profile &&
      authData.token &&
      newAPIAuthData.token &&
      (profile.isAdmin || profile.isManager || profile.isTechnician) &&
      profile.UserRoles &&
      profile.UserRoles.length > 0
    ) {
      this.router.navigateByUrl('/store/product-redirect-loader');
    }
  }

  //This is the login with the new roles, for now not using this
  public login() {
    this.loggingIn = true;
    this.authenticationService
      .login(this.form.username, this.form.password)
      .subscribe(
        (result) => {
          if (result.shop2FAEnbaled || result.user2FAEnabled == true) {
            this.authenticationService.username = this.form.username;
            this.authenticationService.password = this.form.password;
            this.authenticationService.returnUrl = this.returnURL;

            //2FA should be used
            if (
              result.shop2FAEnbaled == false &&
              result.user2FAEnabled == true
            ) {
              //Send to 2FA code screen - User enabled 2FA and no shop has it on
              this.router.navigateByUrl('/2facode');
              return;
            } else if (
              result.shop2FAEnbaled == true &&
              result.user2FAEnabled == true
            ) {
              //Send to 2FA code screen - Shop has 2FA on and user has 2FA registered
              this.router.navigateByUrl('/2facode');
              return;
            } else {
              //User has not enabled 2FA, send to 2FA register screen
              this.router.navigateByUrl('/2fasetup');
              return;
            }
          }

          this.helpersService.saveAuthData(result);
          this.helpersService.saveAuthDataNew(result);

          this.userService.getUserDetail(this.form.username).subscribe(
            (user) => {
              const profile = user;
              const roles = profile.UserRoles.filter((x) => {
                return x.PartnerID > 0;
              });
              var shops = roles
                .map((x) => {
                  return x.PartnerID;
                })
                .filter((value, index, self) => {
                  return self.indexOf(value) === index;
                });

              if (shops.length > 0) {
                var defaultPartnerID = shops[0];
                profile.PartnerID = defaultPartnerID;

                var shopRoles = roles
                  .filter((x) => {
                    return x.PartnerID === defaultPartnerID;
                  })
                  .map((x) => {
                    return x.RoleID;
                  });

                profile.isAdmin = shopRoles.includes(2) || profile.UserRoles.includes(3);
                profile.isManager = shopRoles.includes(3);
                profile.isServiceLead = shopRoles.includes(9);
                profile.isShopRideAdmin = shopRoles.includes(10);
                profile.isTechnician =
                  (shopRoles.includes(1) || shopRoles.includes(4)) &&
                  !profile.isAdmin &&
                  !profile.isManager &&
                  !profile.isServiceLead &&
                  !profile.isShopRideAdmin;
              }
              this.helpersService.saveProfileData(profile);

              this.userService.getUserRolesInsurance(profile.ID).subscribe(
                (permissions) => {
                  this.helpersService.saveProfileInsuranceRoles(permissions);
                },
                (error) => {
                  this.loggingIn = false;
                  this.error = true;
                },
              );

              if (this.returnURL) {
                this.router.navigateByUrl(this.returnURL);
              } else if (profile.IsSuperUser) {
                this.router.navigateByUrl('/administration/stores');
              } else if (profile.isAdmin || profile.isManager || profile.isServiceLead) {
                this.router.navigateByUrl('/store/product-redirect-loader');
              } else if (profile.isTechnician) {
                this.router.navigateByUrl('/store/product-redirect-loader');
              } else if (profile.isShopRideAdmin){
                this.router.navigateByUrl('/store/shop-rides');
              } else {
                //if (isDevMode()) {
                this.router.navigateByUrl('/clubs');
              }
            },
            (error) => {
              this.loggingIn = false;
              this.error = true;
              this.errorMessage =
                'There was an error getting the user profile details. Please try again later.';
            },
          );
        },
        (error) => {
          this.loggingIn = false;
          this.error = true;
          this.errorMessage =
            error && error.error_description
              ? error.error_description
              : 'The email or password is incorrect.';
        },
      );
  }
}
